import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Layout";
import { SITE } from "../lib/site";

export default function MentionsLegales() {
  useEffect(() => { document.title = "Mentions légales | Parfaits Imparfaits"; }, []);

  return (
    <>
      <Seo title="Mentions légales" description="Mentions légales du site parfaitsimparfaits.fr — Valentine DL, praticienne en hypnose spirituelle." />
      <section className="pt-40 pb-12" data-testid="legal-hero">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <p className="eyebrow mb-5">Informations</p>
          <h1 className="text-5xl font-serif font-light text-sand-900">Mentions légales</h1>
        </div>
      </section>

      <section className="pb-32" data-testid="legal-content">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 prose-mystic text-base">
          <h2 className="text-2xl font-serif text-sand-900">1. Éditeur du site</h2>
          <p>
            Le site <strong>parfaitsimparfaits.fr</strong> est édité par {SITE.legal.director},
            praticienne en hypnose régressive et spirituelle, exerçant en qualité d'entrepreneur individuel.
          </p>
          <ul className="list-disc pl-6 space-y-1 text-sand-700">
            <li>Nom commercial : {SITE.name}</li>
            <li>Adresse : {SITE.legal.address}</li>
            <li>E-mail : <a href={`mailto:${SITE.email}`} className="text-sand-500">{SITE.email}</a></li>
            {SITE.legal.siren && <li>SIREN : {SITE.legal.siren}</li>}
            {SITE.legal.siret && <li>SIRET : {SITE.legal.siret}</li>}
          </ul>

          <h2 className="text-2xl font-serif text-sand-900">2. Directrice de la publication</h2>
          <p>{SITE.legal.director}, joignable à l'adresse <a href={`mailto:${SITE.email}`} className="text-sand-500">{SITE.email}</a>.</p>

          <h2 className="text-2xl font-serif text-sand-900">3. Hébergement</h2>
          <p>
            Ce site est hébergé via la plateforme {SITE.legal.hostName}.
            Pour toute demande relative à l'hébergement, écrivez à {SITE.email}.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">4. Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus présents sur le site (textes, images, identité graphique,
            logo, illustrations, articles de blog) est la propriété exclusive de Valentine DL,
            sauf mentions contraires. Toute reproduction, représentation, modification ou
            diffusion, totale ou partielle, sans autorisation écrite préalable est interdite
            et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants
            du Code de la propriété intellectuelle.
          </p>
          <p>
            Les éventuelles photographies issues de banques d'images libres de droit
            (Unsplash, Pexels…) restent la propriété de leurs auteurs respectifs.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">5. Nature des prestations</h2>
          <p>
            Les séances proposées sur ce site sont des accompagnements de mieux-être à
            visée non thérapeutique et non médicale. Elles ne se substituent en aucun
            cas à un avis, diagnostic ou traitement médical, psychologique ou
            psychiatrique. En cas de doute sur votre état de santé, consultez un
            professionnel de santé.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">6. Liens hypertextes</h2>
          <p>
            Le site peut contenir des liens vers d'autres sites web. Valentine DL ne saurait
            être tenue responsable du contenu de ces sites tiers.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">7. Droit applicable</h2>
          <p>
            Le présent site est soumis au droit français. Tout litige relatif à son
            utilisation relève de la compétence des tribunaux français.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">8. Contact</h2>
          <p>
            Pour toute question relative aux présentes mentions légales, vous pouvez
            écrire à <a href={`mailto:${SITE.email}`} className="text-sand-500">{SITE.email}</a>.
          </p>

          <p className="mt-10">
            Consultez également notre <Link to="/politique-de-confidentialite" className="text-sand-500 underline">politique de confidentialité</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
